import { Layout } from "@/components/layout/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Target, Eye, Users, Award } from "lucide-react";

const values = [
  {
    icon: Target,
    title: "Our Mission",
    description: "To bridge global markets with India's finest products, empowering businesses worldwide with reliable B2B trade solutions and exceptional service.",
  },
  {
    icon: Eye,
    title: "Our Vision",
    description: "To become the most trusted name in international trade, known for quality, transparency, and the ability to unlock India's manufacturing potential for global partners.",
  },
  {
    icon: Users,
    title: "Our Approach",
    description: "We combine deep industry expertise with technology-driven processes to ensure seamless transactions, from initial sourcing to final delivery.",
  },
  {
    icon: Award,
    title: "Our Commitment",
    description: "Every partnership is built on trust, quality assurance, and a dedication to exceeding expectations in every aspect of the trade journey.",
  },
];

const About = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="py-24 lg:py-32">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-foreground mb-6">
              About <span className="text-gradient-gold">VIATRA</span>
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-8">
              VIATRA is a premier B2B export company dedicated to connecting global buyers with 
              India's most trusted manufacturers. With a focus on quality, reliability, and 
              seamless international trade operations, we've established ourselves as a bridge 
              between Indian excellence and worldwide demand.
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Our extensive network spans across textiles, agriculture, industrial machinery, 
              handicrafts, and more. We understand the complexities of international trade and 
              work tirelessly to simplify every step for our partners.
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 bg-card/50">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-4">
              What Drives <span className="text-gradient-gold">Us</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {values.map((value) => (
              <div
                key={value.title}
                className="p-8 rounded-2xl bg-gradient-card border border-border"
              >
                <div className="w-14 h-14 rounded-xl bg-secondary flex items-center justify-center mb-6">
                  <value.icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-xl font-serif font-semibold text-foreground mb-3">
                  {value.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground mb-6">
              Ready to <span className="text-gradient-gold">Partner</span> With Us?
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Join hundreds of global businesses that trust VIATRA for their Indian sourcing needs.
            </p>
            <Link to="/contact">
              <Button variant="gold" size="xl">
                Get in Touch
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default About;
